import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { Unity, useUnityContext } from "react-unity-webgl";
import envConfig from "../config.json";
import { Progress, Radio } from "antd";
import { useTheme } from "../components/ThemeContext";

/**
 * Component used to manage Mapper functionality
 */
const Mapper = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const [windowWidth, setWindowWidth] = useState(0);
  const { theme} = useTheme();
  const {
    unityProvider,
    loadingProgression,
    isLoaded,
    sendMessage,
    addEventListener,
  } = useUnityContext({
    loaderUrl: "modelmapping/Build/modelmapping.loader.js",
    dataUrl: "modelmapping/Build/modelmapping.data.unityweb",
    frameworkUrl: "modelmapping/Build/modelmapping.framework.js.unityweb",
    codeUrl: "modelmapping/Build/modelmapping.wasm.unityweb",
  });
  /**
   * Function to used get the token
   */
  const getCdfToken = () => {
    const msalToken = localStorage.getItem("msal.accesstoken");
    const sasToken = localStorage.getItem("sasToken");
    const Token3DCE = localStorage.getItem("accesstokence");
    const unityObj = {
      environment: envConfig.env,
      elixr_base_url: envConfig.aotmwapi,
      cognite_base_url: "",
      middleware_base_url: envConfig.aotmwapi,
      middleware_base_url_ia: "",
      middleware_base_url_smartkpi: "",
      cognite_token: "",
      msal_token: msalToken,
      sas_token: sasToken,
      cognite_ah_rootnode: envConfig.cognite_ah_rootnode,
      access_token_3dce:
        envConfig.application_type === "couple" ? Token3DCE : "",
        theme:theme
    };
    const unityJson = JSON.stringify(unityObj);
    console.log({unityJson});
    sendMessage("HtmlUnityBridge", "OnConfigurationReceived", unityJson);
  };
  /**
   * Function to handle click event
   */
  const handleClick = async (evt) => {
    try {
      navigate(evt.detail.pathName, { replace: true });
    } catch (error) {
      console.log({ error });
    }
  };
  /**
   * Function to handle model change event
   */
  const handleModeChange = async (e) => {
    navigate("/assetmapper", { replace: true });
  };
  /**
   * React hook to handle side effect
   */
  useEffect(() => {
    if (isLoaded) {
      getCdfToken();
    }
    addEventListener("raiseEventFromUnity", function (arg1, arg2) {
      if (arg1 === "Unauthorized") {
        console.log("AuthenticationFailLogOut");
        localStorage.removeItem("checkRole");
        const logoutRequest = {
          postLogoutRedirectUri: envConfig.redirectUri,
        };
        instance.logoutRedirect(logoutRequest);
      }
    });
    const handleWindowResize = () => {
      const widthreduced = (window.innerWidth / 100) * 5;
      setWindowWidth(window.innerWidth - widthreduced);
    };
    window.addEventListener("/mapper", (evt) => {
      handleClick(evt);
    });
    window.addEventListener("resize", handleWindowResize);
    handleWindowResize();
    

    const setWebGLTheme = () => {
      const theme=localStorage.getItem("TwinBuilder3DTheme");
    sendMessage("HtmlUnityBridge", "OnThemeChange",theme);
    };
    window.addEventListener("SetWebGLTheme", setWebGLTheme);
    
    
    return () => {
      window.removeEventListener("resize", handleWindowResize); 
      window.removeEventListener("SetWebGLTheme", setWebGLTheme);
    
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoaded, addEventListener]);

  return (
    <div id="containerFixed">
        <br></br>
        <div className="paddingRow" style={{marginTop: "0px"}}>
          <Radio.Group
            onChange={handleModeChange}
            defaultValue="model"
            buttonStyle="solid"
          >
            <Radio.Button value="model" className="mapperToggleButton">
              MODEL MAPPING
            </Radio.Button>
            <Radio.Button value="mapping" className="mapperToggleButton">
              POI MAPPING
            </Radio.Button>
          </Radio.Group>
        </div>
        <div>
          {!isLoaded ? (
            <Progress
              strokeColor={{
                "0%": "#108ee9",
                "100%": "#87d068",
              }}
              percent={loadingProgression * 100}
              showInfo={false}
            />
          ) : null}
          <div id="unity-container" class="unity-desktop">
            <Unity
              unityProvider={unityProvider}
              style={{
                visibility: isLoaded ? "visible" : "hidden",
                width: `${windowWidth}px`,
                height: "calc(100vh - 150px)",
                marginTop: "-30px",
              }}
              tabIndex={1}
              devicePixelRatio={devicePixelRatio}
            />
          </div>
        </div>
      </div>
  );
};

export default Mapper;
